export default (value: boolean) => {
    if (value) {
        return 'Open';
    }
    return 'Closed';

}